import React, {useState} from "react";
import {useAuth} from "./AuthProvider";
import {useMutation} from "@tanstack/react-query";


let AgencyContext = React.createContext(null);

const AgencyProvider = ({children, criteria, agency, onUpdated, ...props}) => {

    const {auth} = useAuth();

    const [isDisabled, setIsDisabled] = useState(false);
    /*
    |--------------------------------------------------------------------------
    | Handling Requests - Add/Remove Agency to/from Shortlist/Archive
    |--------------------------------------------------------------------------
    */
    const agencyRequestMutation = useMutation(['agencyRequestMutation', agency?.id],
        async ({method, successKey}) => {

            let updatedAgency = await agency[method]()

            if (updatedAgency) {
                TB.sysAlert(successKey);
                return updatedAgency
            }

        }, {
            onError: async (e) => {
                await setIsDisabled(false)
                return TB.showServerErrorToast()
            },
            onSuccess: async (updatedCandidate) => {
                await setIsDisabled(false)
                // if (!updatedCandidate) {
                //     TB.showServerErrorToast()
                //     return false;
                // }
            }
        }
    )
    const runProjectAgencyRequest = async (method, successKey) => {
        await setIsDisabled(true)

        let updatedCandidate = await agencyRequestMutation.mutateAsync(
            {method, successKey}, {
                onError: async (e) => {
                    await setIsDisabled(false)
                    return TB.showServerErrorToast()
                },
                onSuccess: async (updatedCandidate) => {
                    await setIsDisabled(false)
                    // if (!updatedCandidate) {
                    //     TB.showServerErrorToast()
                    //     return false;
                    // }
                }
            });

        console.log('runProjectAgencyRequest', updatedCandidate);

        await setIsDisabled(false)

        return updatedCandidate
    }

    const addToFavorites = async () => {
        return runProjectAgencyRequest(
            'addToFavorites', 'byo.favorites_added'
        );
    }

    const removeFromFavorites = async () => {
        return runProjectAgencyRequest(
            'removeFromFavorites', 'byo.favorites_removed'
        );
    }

    let value = {
        agency,
        criteria,
        isDisabled,
        addToFavorites,
        removeFromFavorites,
        canFavorite: true,
    }

    return (
        <AgencyContext.Provider value={value}>
            {children}
        </AgencyContext.Provider>
    );
}

const useAgency = () => {
    return React.useContext(AgencyContext);
}
export default AgencyProvider;
export {
    useAgency,
    AgencyContext
}